<template lang="pug">
  div.account-orders-page
    .d-flex.flex-row.align-items-center
      font-awesome-icon.account-page__icon(:icon="['far', 'list-alt']")
      h3.account-page__title {{ trans('labels.frontend.account.order-single.order') }} {{ '#' + this.$route.params.number }}
    div
      .alert-notification.alert-notification--danger.d-block.text-center.px-2.px-md-3.mb-3(v-if="order.failed_payment && order.status === 'pending_order'")
        | {{ trans('labels.frontend.account.order-single.cc_failed') }} {{ order.failed_reason }}
      .alert-notification.alert-notification--danger.d-block.text-center.px-2.px-md-3(v-if="order.status === 'canceled'")
        | {{ trans('labels.frontend.account.order-single.canceled_by') }}{{ order.cancel_reason }}
      .alert-notification.alert-notification--warning.d-block.text-center.px-2.px-md-3(v-if="order.status === 'pending_order'")
        strong {{ trans('labels.frontend.account.order-single.auto_cancel_by') }} {{ order.due_date | moment('D MMMM YYYY') }} {{ trans('labels.general.time') }} {{ order.due_date | moment('HH:mm ') }} {{ trans('labels.frontend.account.order-single.without_payment') }}
      nav.progress-steps(v-if="order.status !== 'canceled'")
        .progress-steps__item(v-bind:class="{'progress-steps__item--active': order.status === 'pending_order'}")
          .progress-steps__item-content
            .progress-steps__item-icon
              span 1
            span.progress-steps__item-text.d-block {{ trans('labels.frontend.account.order-single.pending_order') }}
            router-link.btn.btn-primary.btn-sm.mt-1(:to="{ name: 'account.payment-notify' }", :title="trans('menus.frontend.navigation.payment-notify')" v-if="order.status === 'pending_order'") {{ trans('menus.frontend.navigation.payment-notify') }}
        .progress-steps__item(v-bind:class="{'progress-steps__item--active': order.status === 'pending_payment'}")
          .progress-steps__item-content
            .progress-steps__item-icon
              span 2
            span.progress-steps__item-line
            span.progress-steps__item-text {{ trans('labels.frontend.account.order-single.pending_payment') }}
        .progress-steps__item(v-bind:class="{'progress-steps__item--active': order.status === 'pending_shipping'}")
          .progress-steps__item-content
            .progress-steps__item-icon
              span 3
            span.progress-steps__item-line
            span.progress-steps__item-text {{ trans('labels.frontend.account.order-single.pending_shipping') }}
        .progress-steps__item(v-bind:class="{'progress-steps__item--active': order.status === 'shipped'}")
          .progress-steps__item-content
            .progress-steps__item-icon
              span 4
            span.progress-steps__item-line
            span.progress-steps__item-text {{ trans('labels.frontend.account.order-single.shipped') }}
            .d-block.progress-steps__item-text(v-if="order.tracking_number") {{ trans('labels.frontend.account.order-single.tracking_no') }}
              .text-primary {{ order.tracking_number }}
            a.btn.btn-primary.btn-sm.mt-1(
              :href="order.tracking_company.company_tracking_url" v-if="order.tracking_company" title='ติดตามพัสดุ'
              target="_blank"
            ) {{ trans('labels.frontend.account.order-single.check_tracking') }}
    order-summary-table(:order="order" v-if="order")
    order-shipping-billing-details(:order="order" v-if="order")
    div.mt-3
      order-cancellation-modal(:order-id="order.id" @canceled="onOrderCanceled")
      button.btn.btn-primary.btn-sm(@click.prevent="onReOrder" :disabled="loading.isReOrdering")
        span(v-if="!loading.isReOrdering") {{ trans('labels.frontend.account.order-single.re_order') }}
        span(v-if="loading.isReOrdering") {{ trans('alerts.general.please_wait') }}
      button.btn.btn-default.btn-sm(@click.prevent="showCancelModal" v-b-modal.cancelModal v-if="order.status === 'pending_order'") {{ trans('labels.frontend.account.order-single.cancel_order') }}
</template>

<script>
import BreadcrumbsManager from '../../../../mixins/BreadcrumbsManager';
import OrderCancellationModal from '../../../../components/modals/OrderCancellationModal.vue';
import OrderSummaryTable from '../../../../components/order/OrderSummaryTable.vue';
import OrderShippingBillingDetails from '../../../../components/order/OrderShippingBillingDetails.vue';
import { RepositoryFactory } from '../../../../repositoryFactory';
import router from '../../../../routes';

const OrderRepository = RepositoryFactory.get('order');

export default {
  components: {
    OrderCancellationModal,
    OrderSummaryTable,
    OrderShippingBillingDetails,
  },
  mixins: [BreadcrumbsManager],
  metaInfo() {
    return {
      title: `${Lang.get('labels.frontend.account.order-single.order')} #${this.$route.params.number}`,
    };
  },
  data() {
    return {
      order: {},
      loading: {
        isReOrdering: false,
      },
    };
  },
  mounted() {
    this.getOrder();
  },
  methods: {
    async getOrder() {
      const { data } = await OrderRepository.getById(this.$route.params.number).then((resp) => resp.data);
      this.order = data;
      this.setBreadcrumbs([
        { name: Lang.get('labels.frontend.account.order-single.order'), to: { name: 'account.orders' } },
        { name: `#${this.order.number}` },
      ]);
    },
    showCancelModal() {
    },
    onOrderCanceled(order) {
      this.order = { ...this.order, ...order };
    },
    async asyncForEach(array, callback) {
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < array.length; index++) {
        // eslint-disable-next-line no-await-in-loop
        await callback(array[index], index, array);
      }
    },
    async onReOrder() {
      this.loading.isReOrdering = true;
      await this.asyncForEach(this.order.items, async (item) => {
        await this.$store.dispatch('cart/add', {
          cart_id: this.$store.getters['cart/id'],
          item_code: item.item_code,
          quantity: 1,
          redirect: false,
        });
        await new Promise((r) => setTimeout(r, 250));
      });
      this.loading.isReOrdering = false;
      router.push({ name: 'cart' });
    },
  },
};
</script>
